import { toast } from "sonner";
import { api, fmtErr } from "../../api";
import { Menu, MenuItem } from "../bits";

export const WORKSPACE_LABEL = { owner: "Owner", operations: "Operations", estimating: "Estimating" };
const BLURB = { owner: "Performance, cash, approvals and what needs you.", operations: "Jobs, schedule, deliveries and the team on site.", estimating: "Quotes, approvals, materials and costs." };

// Home adapts to the role you are playing today. The choice is remembered per user.
export function WorkspaceSwitch({ value, onChange }) {
  const set = async (w) => {
    if (w === value) return;
    try { await api.patch("/home/workspace", { workspace: w }); onChange(w); } catch (e) { toast.error(fmtErr(e)); }
  };
  return (
    <Menu testid="workspace-switch" className="btn-ghost btn-sm !font-medium" trigger={<span className="t3">Viewing as <span className="t1 font-semibold">{WORKSPACE_LABEL[value] || value}</span></span>}>
      <div className="eyebrow px-2.5 pb-1 pt-1.5 !text-[10px]">Home view</div>
      {Object.keys(WORKSPACE_LABEL).map((w) => (
        <MenuItem key={w} onClick={() => set(w)} testid={`workspace-${w}`}>
          <span className={`block ${w === value ? "font-semibold" : ""}`}>{WORKSPACE_LABEL[w]}</span><span className="t3 block text-[11px]">{BLURB[w]}</span>
        </MenuItem>
      ))}
    </Menu>
  );
}
